import { useCallback } from 'react';
import { createSelector } from 'reselect';
import { getChannelListApi, getHasAuthAccountApi } from './api';
import { useSelector, useDispatch } from '../../../react-redux';
import { setChannelList, setHasAuthAccount } from '../../../reducers/channel';

const formatList = (list = [], parent = null) => {
  const data = [];

  list.forEach(item => {
    const obj = {};
    const { sub_source, name, display_name } = item;
    if (sub_source && sub_source.length) {
      obj.children = formatList(sub_source, item);
    }

    obj.value = parent ? `${parent.name}.${name}` : name;
    obj.label = display_name || name;
    data.push(obj);
  });
  if (parent?.name === 'web') data.push({ label: '默认接入渠道', value: 'web.default' });
  return data;
};

//扁平化数据
const flat = (list = [], parent = null) => {
  const data = [];
  list.forEach(item => {
    const obj = {};
    const { sub_source, name, display_name } = item;
    if (sub_source && sub_source.length) {
      data.push(...formatList(sub_source, item));
    }
    obj.label = display_name || name;
    obj.value = parent ? `${parent.name}.${name}` : name;
    data.push(obj);
  });
  return data;
};

const getChannelTree = createSelector([agents => agents], agents => formatList(agents));
const getFlatChannel = createSelector([agents => agents], agents => [
  ...flat(agents),
  { label: '默认接入渠道', value: 'web.default' }
]);

const useChannel = () => {
  const dispatch = useDispatch();
  const channelList = useSelector(state => state.getIn(['channel', 'channelList']));
  const hasAuthAccount = useSelector(state => state.getIn(['channel', 'hasAuthAccount']));
  const channelTree = useSelector(state => getChannelTree(state.getIn(['channel', 'channelList'])));
  const flatChannel = useSelector(state => getFlatChannel(state.getIn(['channel', 'channelList'])));
  const getChannelList = useCallback(async () => {
    const res = await getChannelListApi();
    const data = res?.data?.source || [];
    dispatch(setChannelList({ data }));
  }, []);
  const getHasAuthAccount = useCallback(async () => {
    try {
      const res = await getHasAuthAccountApi();
      dispatch(setHasAuthAccount(res));
    } catch {}
  }, []);

  return {
    hasAuthAccount,
    channelList,
    channelTree,
    flatChannel,
    getChannelList,
    getHasAuthAccount
  };
};

export default useChannel;
